module.exports = "../../softuni-courses.JPG";